import * as React from 'react'

import { Form, Input } from 'antd'
import { FormattedMessage, useIntl } from 'react-intl'
import { FormInstance, Rule } from 'antd/lib/form'
import { HKTStruct, Item } from '../../types'
import { option } from 'fp-ts'
import { Store } from 'antd/lib/form/interface'
import { flow, pipe } from 'fp-ts/lib/function'
import { ColProps } from 'antd/lib/col'
import { FormLayout } from 'antd/lib/form/Form'
import ItemPrices from './ItemPrices'

export type OptionalItem = HKTStruct<'Option', Omit<Item, 'id'>>

type ExtraRules = Partial<{ [k in keyof OptionalItem]: Rule[] }>

type Props = {
  form?: FormInstance
  onChange?: (_: OptionalItem) => void
  labelCol?: ColProps
  wrapperCol?: ColProps
  layout?: FormLayout
  extraRules?: ExtraRules
  onFinish?: (_: OptionalItem) => void
  initialValues?: Item
}

const storeToItem = (s: Store): OptionalItem => ({
  name: option.fromNullable(s?.name),
  description: pipe(
    option.fromNullable(s?.description),
    option.alt(() => option.some(''))
  ),
  price: option.fromNullable(s?.price),
})

const ItemForm = ({
  form,
  onChange,
  onFinish,
  extraRules,
  labelCol,
  wrapperCol,
  initialValues,
}: Props) => {
  const intl = useIntl()

  return (
    <Form
      form={form}
      onValuesChange={(_, v) => {
        if (!!onChange) {
          onChange(storeToItem(v))
        }
      }}
      labelCol={labelCol}
      wrapperCol={wrapperCol}
      onFinish={!!onFinish ? flow(storeToItem, onFinish) : () => {}}
      initialValues={initialValues}
    >
      <Form.Item
        label={<FormattedMessage id="name" />}
        name="name"
        rules={[
          ...(extraRules?.name ?? []),
          {
            required: true,
            message: <FormattedMessage id="required" />,
          },
        ]}
      >
        <Input placeholder={intl.formatMessage({ id: 'itemName' })} />
      </Form.Item>
      <Form.Item
        label={<FormattedMessage id="description" />}
        name="description"
        rules={extraRules?.description}
      >
        <Input placeholder={intl.formatMessage({ id: 'itemDescription' })} />
      </Form.Item>
      <Form.Item
        label={<FormattedMessage id="price" />}
        name="price"
        rules={[
          ...(extraRules?.price ?? []),
          {
            required: true,
            message: <FormattedMessage id="required" />,
          },
        ]}
      >
        <ItemPrices />
      </Form.Item>
    </Form>
  )
}

export default ItemForm
